export default {
    prefix: 'custom',
    iconName: 'phone2',
    icon: [
        40, 40,

        [],
        null,
        'M29.5 25.2C28.3 24.1 27 23 25.6 22c-.4-.2-.8-.2-1.1 0-.2.1-.4.3-.6.5-.5.7-1.2 1.3-1.9 1.8-1.1.6-3.8-1.9-3.8-1.9l-.4-.4s-2.5-2.7-1.9-3.8c.5-.7 1.1-1.4 1.8-1.9.2-.2.4-.4.5-.6.2-.4.2-.8 0-1.2-1-1.4-2-2.7-3.2-3.9-.2-.2-.5-.4-.8-.5-.2-.1-.5-.1-.7 0-1 .8-1.9 1.7-2.8 2.6 0 0-1 1-.4 3.6.9 3.3 2.6 6.3 4.9 8.7 2.4 2.3 5.4 4 8.6 4.8 2.7.6 3.6-.4 3.6-.4.9-.9 1.8-1.8 2.6-2.8.1-.2.1-.5 0-.7-.1-.2-.2-.5-.5-.7z'

    ]
};